import { NewDataSetResponse } from "./new-data-set-response";
import { DetallePedidoCliente } from "./detalle-pedido-cliente";
import { Tercero } from "./tercero";

/**
 * Clase homóloga del sistema de sigamos que hace referencia a RepPedidoClienteDTO
 * 
 * @author Andrés Felipe Vargas López
 * @version Nov 28, 2018
 * @since 1.8
 */
export class PedidoCliente {

    peclId : number;
	consecutivoPedido : number;
	descuentoEspecial : number;
	maximoDescuento : number;
	
	itemsPedidos : number;
	piezasPedidas : number;
	valorPedido : number;
    ivaPedido : number;
    
    itemsComprometidos : number;
    piezasComprometidas : number;
    valorComprometido : number;
    ivaComprometido : number;
    valorDescuentoAplicado : number;
    fechaCreacion : Date;
    usuarioCreador : string;
    
    detallesPedido : Array<DetallePedidoCliente>;

    numeroGuia : string;
    enviaWebTrackingResponse : NewDataSetResponse;
    linkFactura : string;

    nombreSucursal : string;
    direccion : string;

    dias: number;
    costoFlete: number;

    descripcionPago: string;
    referenceCode: string;

    constructor(){}
}
